import { getValue } from "@/shared/RxUtil";
import { checkIsDefined } from "@/shared/Preconditions";
const AUTH_REQUIRED = "Authentication is required to follow a user.";
export class FollowUserUseCaseImpl {
    constructor(userRepository, authRepository) {
        this.userRepository = userRepository;
        this.authRepository = authRepository;
    }
    async run(userId) {
        const currentUserId = await getValue(this.authRepository.userId);
        checkIsDefined(currentUserId, AUTH_REQUIRED);
        return this.userRepository.followUser(userId, currentUserId);
    }
}
